import InstallationFilterButton from './InstallationFilterButton.vue'; //eslint-disable-line

export default InstallationFilterButton



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/components/app-filter/installation-filter-button/index.js